import Vue from 'vue'
import Quasar, { Notify, Dialog, Loading } from 'quasar'
import '@quasar/extras/material-icons/material-icons.css'
import 'quasar/dist/quasar.css'

Vue.use(Quasar, {
  config: {
    brand: {
      // primary: '#5740d4',
      // primary: '#4f46e5',
      primary: '#1a6ad9',
      secondary: '#e59b46',
      accent: '#9C27B0',
      dark: '#1d1d1d',
      positive: '#21BA45',
      negative: '#C10015',
      info: '#31CCEC',
      warning: '#F2C037'
    },
    notify: {
      position: 'top',
      timeout: 3000
    }
  },
  plugins: {
    Notify,
    Dialog,
    Loading
  }
})


